import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';

export const searchTheme: ThemeOptions['components'] = {
  DsSearch: {
    styleOverrides: {
      root: {
        width: 500,
      },
      notFound: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        padding: '8px 10px',
      },
      criteriaSearch: {},
      criteriaSearchLabel: ({ theme }) => ({
        padding: '11px 8px 5px 8px',
        color: tokens.theme.fg.structural.secondary,
        ...theme.typography.L10B,
      }),
      criteriaSearchList: ({ theme }) => ({
        display: 'flex',
        flexWrap: 'wrap',
        padding: '8px',
        gap: '8px',

        '.DsChip-root': {
          backgroundColor: tokens.theme.bg.categorical.indigoStrong,
          color: tokens.theme.fg.categorical.onIndigoStrong,
          ...theme.typography.P12M,
        },
      }),
      recentSearch: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflowY: 'hidden',
      },
      recentSearchLabel: ({ theme }) => ({
        padding: '11px 8px 5px 8px',
        color: tokens.theme.fg.structural.secondary,
        ...theme.typography.L10B,
      }),
      options: {
        position: 'relative',
      },
      optionsListItem: ({ ownerState }) => ({
        ...(ownerState?.allowMultiple
          ? { '.DsListItem-content': { display: 'flex', gap: '8px' } }
          : {}),
      }),
    },
  },
};
